import React from 'react'

const TextInputMessage = ({ value, onChange }) => {
  return (
    <div>
      <label className="block text-gray-700 mb-2" htmlFor="message">
        Pesan
      </label>
      <textarea
        id="message"
        name="message"
        value={value}
        onChange={onChange}
        rows="4"
        placeholder="Tulis pesan Anda di sini"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        required
      ></textarea>
    </div>
  )
}

export default TextInputMessage